import FormWidget from "../form-widget.js";

const bootstrap = window.bootstrap;

interface DataListItem {
    label: string;
    value: string;
}
interface ValuePickerhWidgetOptions {
    valuePickerItems: DataListItem[];
}

const defaultOptions: ValuePickerhWidgetOptions  = {
    valuePickerItems: []
};

class ValuePickerhWidget extends FormWidget {
    protected options: ValuePickerhWidgetOptions;
    public override init() {
        this.options = this.assignConfig<ValuePickerhWidgetOptions>(defaultOptions, this.config);
    }
    public override process() {
        const fieldEl = this.element as HTMLInputElement;

        let items: DataListItem[] = this.options.valuePickerItems ?? [];
        if(fieldEl.dataset.valuePickerItems) {
            const temp: Array<Array<string>> = JSON.parse(fieldEl.dataset.valuePickerItems);
            temp.forEach((item) => {
                const dataListItem: DataListItem = {
                    label: item[0],
                    value: item[1]
                }
                items.push(dataListItem);
            });
        }
        const formElementEl = fieldEl.closest<HTMLElement>('.form-element');

        let dataListId = 'datalist_' + globalThis.crypto.randomUUID();

        if(formElementEl && fieldEl.getAttribute('list')) {
            const dataListEl = formElementEl.querySelector('datalist');
            if(dataListEl) {
                if(dataListEl.hasAttribute('id')) {
                    dataListId = dataListEl.getAttribute('id')!;
                }
                items = [];
                dataListEl.querySelectorAll<HTMLOptionElement>('option').forEach((optionEl: HTMLOptionElement) => {
                    const val = optionEl.getAttribute('value');
                    if(val) {
                        items.push({ label: optionEl.innerHTML, value: val });
                    }

                });

                dataListEl.remove();
            }
        }
        if(items && items.length > 0) {
            const itemsEl = document.createElement('div');
            itemsEl.setAttribute('class', 'list-group list-group-flush');
            for(const key in items) {
                const item: DataListItem = items[key];
                const itemEl: HTMLAnchorElement = document.createElement('a');
                itemEl.setAttribute('class', 'list-group-item list-group-item-action');
                itemEl.style.cursor = 'pointer';
                itemEl.innerHTML = item.label;
                itemEl.addEventListener('click', () => {
                    fieldEl.value = item.value;
                });
                itemsEl.append(itemEl);
            }
            if(!fieldEl.parentElement?.classList.contains('input-group')) {
                const wrapperEl = document.createElement('div');
                wrapperEl.classList.add('input-group');
                fieldEl.after(wrapperEl);
                wrapperEl.append(fieldEl);
            }

            const buttonEl = document.createElement('button');
            buttonEl.setAttribute('class', 'btn btn-outline-form');
            buttonEl.setAttribute('type', 'button');
            buttonEl.setAttribute('data-bs-toggle', 'dropdown');
            buttonEl.setAttribute('data-bs-target', '#'+dataListId);
            buttonEl.setAttribute('aria-expanded', 'false');
            buttonEl.innerHTML = '<span class="bi bi-chevron-down"></span>';

            fieldEl.after(buttonEl);

            const dropDownMenuEl = document.createElement('div');
            dropDownMenuEl.setAttribute('id', dataListId)
            dropDownMenuEl.setAttribute('class', 'dropdown-menu dropdown-menu-end')
            dropDownMenuEl.append(itemsEl);

            buttonEl.after(dropDownMenuEl);

            bootstrap.Dropdown.getOrCreateInstance(buttonEl);
        }

    }

}

export type { ValuePickerhWidgetOptions, DataListItem };
export default ValuePickerhWidget;
